// BatteryFly × Caldera — light industrial system
// Soft White canvas · Green Charge as the single dominant accent · Amber for secondary CTAs
// Carbon Core for dark/contrast sections · condensed display type · flat, shadowless, 40px radii

const palette = {
  canvas: 'rgba(240, 239, 234, 1)',       // warm soft white — page background (pumice role)
  surface: 'rgba(255, 255, 255, 1)',      // cards / header pill (limestone role)
  ink: 'rgba(23, 26, 29, 1)',             // Carbon Core — text, headings, borders (obsidian role)
  chalk: 'rgba(255, 255, 255, 1)',        // text on dark/accent surfaces
  accent: 'rgba(111, 143, 91, 1)',        // Green Charge — primary accent (ember role)
  accentHover: 'rgba(95, 117, 78, 1)',    // darker green
  accentSoft: 'rgba(156, 193, 132, 1)',   // light green — tags/badges (sulfur role)
  amber: 'rgba(201, 138, 61, 1)',         // Amber Ignition — secondary accent
  muted: 'rgba(115, 122, 128, 1)',        // graphite — secondary text
};

export const theme = {
  colors: {
    // legacy tokens (kept so all existing components keep working) — remapped to green/amber on light
    textPrimary: palette.ink,
    textDisabled: palette.muted,
    greyOutput: 'rgba(115, 122, 128, 1)',
    greyPlaysholder: 'rgba(138, 144, 150, 1)',
    greyBackgroundPaper: palette.surface,
    greyPrimary: 'rgba(23, 26, 29, 0.12)',

    secondary: palette.accent,          // brand/primary accent = Green Charge
    hoverColor: palette.amber,          // hover / secondary CTA = Amber
    background: palette.canvas,         // page canvas = warm soft white

    gradient: 'linear-gradient(rgba(111, 143, 91, 1), rgba(111, 143, 91, 0))',
    gradientYellow: 'linear-gradient(rgba(156, 193, 132, 1), rgba(136, 168, 111, 1))',
    gradientHover: 'linear-gradient(rgba(201, 138, 61, 1), rgba(201, 138, 61, 0))',
    gradientBlack: 'linear-gradient(rgba(23, 26, 29, 1), rgba(42, 47, 51, 1))',
    gradientBackground:
      'linear-gradient(rgba(111, 143, 91, 0.04), rgba(111, 143, 91, 0.28), rgba(111, 143, 91, 0))',
    gradientSubNavGrey: 'linear-gradient(rgba(255, 255, 255, 1), rgba(246, 245, 242, 0))',
    warning: 'rgba(201, 138, 61, 1)',
    error: 'rgba(214, 69, 69, 1)',
    success: 'rgba(95, 117, 78, 1)',
  },

  // Caldera design tokens
  brand: palette,
  radii: {
    card: '40px',
    button: '40px',
    pill: '800px',
    input: '100px',
    medium: '20px',
    small: '16px',
  },
  fonts: {
    display: "'Oswald', 'Inter', sans-serif", // condensed industrial (Cyrillic) — headings/display
    body: "'Inter', sans-serif",              // body / UI
  },
  layout: {
    maxWidth: '1280px',
    sectionGap: '80px',
    cardPadding: '40px',
  },
  transition: {
    main: '400ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
};
